import { action, observable, makeObservable } from 'mobx';
import { LocalStore } from "./LocalStore";
import { PromotionStore } from './PromotionStore';
import { CartStore } from './CartStore';
import { UserStore } from './UserStore';
import { BREAKPOINTS } from '../layout';

export class DominosRootStore {
    localStore: LocalStore;
    promoStore: PromotionStore;
    cartStore: CartStore;
    userStore: UserStore;

    @observable debugMessage: string;

    @observable isMBreakpoint: boolean;
    @observable headerHeight = 0;

    CODE_PRICE_CHANGED = 'dominos.errors.ecommerce.pricechanged';
    CODE_EMPTY_CART = 'dominos.errors.ecommerce.emptycart';
    CODE_CART_MINVALUE = 'dominos.errors.ecommerce.minimalordervalue';

    constructor() {
        makeObservable(this);
        this.userStore = new UserStore(this);
        this.localStore = new LocalStore(this);
        this.cartStore = new CartStore(this);
        this.promoStore = new PromotionStore(this);

        this.checkViewport();
    }

    @action setDebugMessage = (message: string) => {
        this.debugMessage = message;
    }

    checkViewport = () => {
        const mql = window.matchMedia(`(min-width:${BREAKPOINTS.M}px)`);
        this.changeBreakpointAction(mql);

        // Old method because of iOS bug
        mql.addListener(this.changeBreakpointAction);
        // mql.addEventListener('change', this.changeBreakpointAction);
    }

    @action changeBreakpointAction = (mql: MediaQueryListEvent | MediaQueryList ) => {
        this.isMBreakpoint = mql.matches;

        const menu = document.querySelector('[data-jsmodule=MainMenu]');
        if (menu) {
            this.headerHeight = menu.clientHeight - 1;
        }
    }

    /**
     * Move view to the top
     *
     * @memberof DominosRootStore
     */
    moveToTop = () => {
        const hght = this.headerHeight;
        if (window.scrollY > hght) {
            window.scrollTo(0, hght);
        }
    }
}
